import {combineReducers} from 'redux';
import theme from './theme/themeSlice';
import auth from './auth';
import base from './base';
import locale from './locale/localeSlice';
import {apiSlice} from './api/apiSlice';

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        [apiSlice.reducerPath]: apiSlice.reducer,
        ...asyncReducers,
    });
    return combinedReducer(state, action);
};

export default rootReducer;
